<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Új kampány') }}</h1>

        <c-control-text class="mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="name" required
                        v-bind:invalid="!!requestStore.errors?.name"
                        v-bind:label="__('Megnevezés')"
                        v-model="campaign.name"
        />

        <c-control-text class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="description" type="textarea"
                        v-bind:invalid="!!requestStore.errors?.description"
                        v-bind:label="__('Leírás')"
                        v-bind:rows="2"
                        v-model="campaign.description"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="old_price" placeholder="1000"
                        v-bind:invalid="!!requestStore.errors?.old_price"
                        v-bind:label="__('Áthúzott ár')"
                        v-bind:min="1"
                        v-model="campaign.old_price"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="price" placeholder="500"
                        v-bind:invalid="!!requestStore.errors?.price"
                        v-bind:label="__('Új ár')"
                        v-bind:min="1"
                        v-model="campaign.price"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="points" placeholder="150" required
                        v-bind:invalid="!!requestStore.errors?.points"
                        v-bind:label="__('Levonandó pontok')"
                        v-bind:min="1"
                        v-model="campaign.points"
        />

        <c-control-file class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="picture" required
                        v-bind:invalid="!!requestStore.errors?.picture"
                        v-bind:filenames="filenames"
                        v-bind:label="__('Kép')"
                        v-model="files"
        />

        <img class="max-w-96 mt-2 mx-auto"
             v-bind:alt="campaign.name"
             v-bind:src="files[0]"
             v-if="files[0]"
        />

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-on:click="submit"
        >
            {{ __('Mentés') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import {
        CButton,
        CControlFile,
        CControlNumber,
        CControlText,
    } from '@teamfurther/cinderblock';
    import CampaignRepository from '../../repositories/CampaignRepository';
    import { useRequestStore } from '../../stores/request';

    const campaign = ref({
        description: '',
        name: '',
        old_price: null,
        picture: '',
        points: 100,
        price: null,
    });
    const campaignRepository = new CampaignRepository();
    const files = ref([]);
    const filenames = ref([]);
    const requestStore = useRequestStore();

    async function submit() {
        campaign.value.picture = files.value[0];

        campaign.value = await campaignRepository.store(campaign.value);
    }

    onMounted(() => {
        files.value = [campaign.value.picture];
    });
</script>
